const part = [
    {
        path: 'brand-list',
        name: 'brand-list',
        meta: {
            icon: 'md-cube',
            title: '品牌管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/product-management/brand-management/brand-list')
    }
];

export default part;
